import { DEFAULT_PAGE_SIZE } from "common/config";
import { DocDetailsState } from "../../models/document-details-state.model";

// check if url has page and size params, if so then use them as initial values
const urlParams = new URLSearchParams(window.location.search);
const page = urlParams.get("page");
const size = urlParams.get("size");

const initialDocDetailsState: DocDetailsState = {
  pageDetails: {
    page: page ? parseInt(page) : 1,
    size: size ? parseInt(size) : DEFAULT_PAGE_SIZE,
    search: "",
    sort: "",
    dir: ""
  }
};

export { initialDocDetailsState };
